module.exports = __webpack_public_path__ + "static/media/syncing-data.1d1238fa.png";